"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLocalizedHref = useLocalizedHref;
const localization_constants_1 = require("./localization.constants");
const use_locale_1 = require("./use-locale");
function useLocalizedHref(href) {
    const locale = (0, use_locale_1.useLocale)();
    if (locale === localization_constants_1.DEFAULT_LOCALE) {
        return href;
    }
    else {
        return `/${locale}${href}`;
    }
}
//# sourceMappingURL=use-localized-href.js.map